package com.crowpay.views.screens.contractor

import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.selectedContractor
import com.crowpay.views.components.EditSpecifications
import com.crowpay.views.theming.title
import com.lightningkite.UUID
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.models.dp
import com.lightningkite.kiteui.navigation.render
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.padded
import com.lightningkite.kiteui.views.direct.scrolls
import com.lightningkite.kiteui.views.direct.sizeConstraints
import com.lightningkite.kiteui.views.direct.stack

@Routable("contractor/specifications")
class Specifications() : ContractorPage {
    override fun ViewWriter.renderMainContent() {
        scrolls - col {
            spacing = 0.dp

            title("Specifications")

            val editSpecifications = EditSpecifications(
                contractorId = selectedContractor.state.get() ?: UUID.random(),
                onSave = { spec -> }
            )
            sizeConstraints(width = AppDimensions.pageWidth) - padded - stack {
                spacing = AppDimensions.backgroundIndent
                editSpecifications.render(this)
            }
        }
    }
}